import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

function MasterRevenueType() {
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/dsp-revenue-type/table`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.per_page);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const handleDelete = async item => {
    try {
      await axios.delete(
        `${hardBaseUrl}/dsp-revenue-type/delete/${item.dsp_id}`,
        { headers }
      );
      ModalSuccess("Data has been deleted").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Fragment>
      <Page className={classes.root} title="DSP Type Revenue">
        <Container maxWidth={false}>
          <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
          <ButtonGroupTop />
          <Divider className={classes?.flatDivider} />
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            my="16px"
          >
            <Grid item>
              <SearchTextInput
                placeholder="Search"
                value={queryParams?.search}
                onChange={e =>
                  handleChangeQueryParams(e?.target?.value, "search")
                }
                disabled={loadingPage}
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Add DSP Revenue Type"
                startIcon={<Add />}
                onClick={() =>
                  history.push("/admin/konfigurasi/dsp-type-revenue/add")
                }
                size="large"
                disabled={loadingPage}
              />
            </Grid>
          </Grid>
          <CustomTable
            isLoading={loadingPage}
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.per_page}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "per_page")
            }
            isHaveAction
            handleEdit={item =>
              history.push({
                pathname: `/admin/konfigurasi/dsp-type-revenue/edit/${item.dsp_id}`,
                state: { dsp: item },
              })
            }
            handleDelete={handleDelete}
            deleteConfirmation
            deleteConfirmationKey="name"
          />
        </Container>
      </Page>
    </Fragment>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/dsp-type-revenue",
  },
  {
    label: "DSP Type Revenue",
    active: true,
  },
];
const columnTable = [
  {
    name: "name",
    title: "DSP Name",
  },
  {
    name: "dsp_revenue_types",
    title: "Revenue Type",
    renderText: item => {
      const modifiedItems = item
        ?.map(revenue => revenue?.revenue_type?.name)
        ?.filter(name => name);
      return <ArrayChip list={modifiedItems} max={3} />;
    },
  },
];
export default MasterRevenueType;
